var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg00555IconServiceIntegrationServiceEnvironments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "f25af711-9b7f-4e33-92dc-aac4716591f3",
    cx: 9.044,
    cy: 8.913,
    r: 10.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#5ea0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a305fb35-e815-4445-a184-35cb29dae4a9",
    x1: 5.344,
    y1: 10.72,
    x2: 5.344,
    y2: 13.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#76bc2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e9624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a936de98-dcd2-4eeb-b313-9efe1853d9b9",
    x1: 12.646,
    y1: 10.72,
    x2: 12.646,
    y2: 13.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#76bc2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e9624"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-555Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b2cb9dea-a960-4191-9d13-86e5f131cf43"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.863,
    fill: "url(#f25af711-9b7f-4e33-92dc-aac4716591f3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7.386,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.432,8.665V7.475H8.594v1.19a.168.168,0,0,1-.168.168H5.272a.335.335,0,0,0-.335.335v1.545h.838V9.857a.167.167,0,0,1,.167-.167h6.105a.167.167,0,0,1,.167.167v.874h.838V9.168a.335.335,0,0,0-.335-.335H9.6A.168.168,0,0,1,9.432,8.665Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.551,3.862H7.41a.347.347,0,0,0-.347.347V7.35A.347.347,0,0,0,7.41,7.7h3.141A.347.347,0,0,0,10.9,7.35V4.209A.347.347,0,0,0,10.551,3.862Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.551,3.862H7.41a.347.347,0,0,0-.347.347V7.35A.347.347,0,0,0,7.41,7.7h3.141A.347.347,0,0,0,10.9,7.35V4.209A.347.347,0,0,0,10.551,3.862Zm-.3,2.96a.23.23,0,0,1-.23.23H7.938a.23.23,0,0,1-.23-.23V4.737a.23.23,0,0,1,.23-.23h2.085a.23.23,0,0,1,.23.23Z",
    fill: "#a67af4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "bdc94428-22ed-41e6-a140-3d9647e53950",
    d: "M6.715,13.185V11a.279.279,0,0,0-.279-.279H4.251A.279.279,0,0,0,3.972,11v2.186a.279.279,0,0,0,.279.279H6.436A.279.279,0,0,0,6.715,13.185Z",
    fill: "url(#a305fb35-e815-4445-a184-35cb29dae4a9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a551ca4d-bd02-42d4-b100-f5246ebf0f81",
    d: "M14.018,13.185V11a.279.279,0,0,0-.279-.279H11.553a.279.279,0,0,0-.279.279v2.186a.279.279,0,0,0,.279.279h2.186A.279.279,0,0,0,14.018,13.185Z",
    fill: "url(#a936de98-dcd2-4eeb-b313-9efe1853d9b9)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg00555IconServiceIntegrationServiceEnvironments);
export default __webpack_public_path__ + "static/media/00555-icon-service-Integration-Service-Environments.6590fa7fec1b6bc8553c129e05da681c.svg";
export { ForwardRef as ReactComponent };